import * as GROUPBREAKDOWN_PAYLOADS from './groupbreakdown';

import * as OCCURRENCE_PAYLOADS from './occurrences';
import * as SIMPLECOUNT_PAYLOADS from './simplecount';
import * as TRENDWIDGET_PAYLOADS from './trendwidget';

const PAYLOADS = {
    ...GROUPBREAKDOWN_PAYLOADS,
    ...OCCURRENCE_PAYLOADS,
    ...SIMPLECOUNT_PAYLOADS,
    ...TRENDWIDGET_PAYLOADS,
};

export default PAYLOADS;
